import { useState } from 'react';

const MediaModal = ({ onClose, onAddMedia }) => {
  const [type, setType] = useState("image");
  const [link, setLink] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState(null);

  const handleTypeChange = (e) => {
    setType(e.target.value);
    setLink("");
    setFile(null);
    setPreview(null);
    setError(null);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type.match("image.*")) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
      setError(null);
    } else {
      setError("Format d'image invalide (JPG/PNG)");
    }
  };

  const handleAdd = () => {
    if (type === "image" && !file) {
      setError("Veuillez sélectionner une image");
      return;
    }
    if ((type === "video" || type === "musique") && !link) {
      setError("Veuillez insérer un lien valide");
      return;
    }

    onAddMedia({
      type,
      file: type === "image" ? file : null,
      link: type !== "image" ? link : null,
    });
    onClose();
  };

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: "#1a1a1a",
        border: "2px solid #00ff00",
        padding: "20px",
        width: "500px",
        maxWidth: "90%",
      }}>
        <h3 style={{ textAlign: "center", color: "#00ff00" }}>Ajouter un média</h3>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ color: "#00ff00" }}>Type de média:</label>
          <select
            value={type}
            onChange={handleTypeChange}
            style={{
              backgroundColor: "#2a2a2a",
              color: "#00ff00",
              border: "1px solid #00ff00",
              padding: "8px",
              width: "100%",
            }}
          >
            <option value="image">Image</option>
            <option value="video">Vidéo</option>
            <option value="musique">Musique</option>
          </select>
        </div>

        {type === "image" ? (
          <div>
            <label style={{ color: "#00ff00" }}>Sélectionner une image:</label>
            <input
              type="file"
              onChange={handleFileChange}
              style={{ display: "block", margin: "10px 0" }}
            />
            {preview && (
              <img
                src={preview}
                alt="Preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "200px",
                  border: "1px solid #00ff00",
                  margin: "10px 0",
                }}
              />
            )}
          </div>
        ) : (
          <div>
            <label style={{ color: "#00ff00" }}>
              Lien {type === "video" ? "YouTube" : "SoundCloud/Spotify"}:
            </label>
            <input
              type="text"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder={`Lien vers la ${type}`}
              style={{
                backgroundColor: "#2a2a2a",
                color: "#00ff00",
                border: "1px solid #00ff00",
                padding: "8px",
                width: "100%",
              }}
            />
          </div>
        )}

        {error && <p style={{ color: "#ff0000" }}>{error}</p>}

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
          <button
            onClick={onClose}
            style={{
              backgroundColor: "#ff0000",
              color: "#fff",
              border: "none",
              padding: "10px 20px",
              cursor: "pointer",
            }}
          >
            Annuler
          </button>
          <button
            onClick={handleAdd}
            style={{
              backgroundColor: "#00ff00",
              color: "#000",
              border: "none",
              padding: "10px 20px",
              cursor: "pointer",
            }}
          >
            Ajouter
          </button>
        </div>
      </div>
    </div>
  );
};

export default MediaModal;
